import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PageTitle } from "../../../_start/layout/core";
import { CreateMember } from "./pages/members/CreateMember";
import MembersPage from "./pages/members/MembersPage";
import PendingApprovalsPage from "./pages/members/PendingApprovalsPage";
import { UpdateMember } from "./pages/members/UpdateMember";

export const UserManagementPage = () => {
  return (
    <Routes>
      <Route
        path="members"
        element={
          <>
            <PageTitle>Members</PageTitle>
            <MembersPage />
          </>
        }
      />
      <Route
        path="members/:member_id/update"
        element={
          <>
            <PageTitle>Members</PageTitle>
            <UpdateMember />
          </>
        }
      />
      <Route
        path="members/create"
        element={
          <>
            <PageTitle>Members</PageTitle>
            <CreateMember />
          </>
        }
      />
      <Route
        path="pending"
        element={
          <>
            <PageTitle>Pending approvals</PageTitle>
            <PendingApprovalsPage />
          </>
        }
      />

      <Route
        index
        element={<Navigate to="/user-management/members" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/user-management/members" replace />}
      />
    </Routes>
  );
};
